var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "section-card",
    class: {
      'section-card--highlight': _vm.highlight,
      'mt-4': !_vm.highlight && _vm.spaced
    },
    attrs: {
      "elevation": "0",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "section-header"
  }, [_c('v-icon', {
    staticClass: "mr-2 section-header-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.title))];
  })], 2), _c('v-card-text', [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }